'use strict';

var base64_url_decode = require('./base64_url_decode');

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new Error('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  return JSON.parse(base64_url_decode(token.split('.')[pos]));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/jwt-decode/lib/index.js
 ** module id = 1298
 ** module chunks = 0
 **/